<script>
  import { operationStore, query } from "@urql/svelte";
  import { Starvortraege } from "../../Api/congress";
  import { IMSpezial } from "../../Api/congress";
  import { Teilnehmerkongresstermine } from "../../Api/congress";

  const requestPolicy = "network-only";

  export let congressId;

  let showStarvortraegeList = false;
  let showIMSpezialList = false;
  let showModeratorList = true;
  let showReservedList = true;
  let showWaitingList = true;

  let keynotesspeaker = [];
  let imspezial = [];
  let teilnehmerkongresstermine = [];
  let hasModeratorTermin = false;

  let inProgressStarvortraege = false;

  const congressStarvortraege = operationStore(Starvortraege, { congressId }, { requestPolicy });

  query(congressStarvortraege);

  congressStarvortraege.subscribe((storeObjStarvortraege) => {
    inProgressStarvortraege = storeObjStarvortraege.fetching;
    if (!inProgressStarvortraege && storeObjStarvortraege.data) {
      keynotesspeaker = storeObjStarvortraege.data.starvortraegedata;
    }
  });

  let inProgressTeilnehmertermine = false;

  const congressTeilnehmertermine = operationStore(Teilnehmerkongresstermine, { congressId }, { requestPolicy });

  query(congressTeilnehmertermine);

  congressTeilnehmertermine.subscribe((storeObjTeilnehmertermine) => {
    inProgressTeilnehmertermine = storeObjTeilnehmertermine.fetching;
    if (!inProgressTeilnehmertermine && storeObjTeilnehmertermine.data) {
      teilnehmerkongresstermine = storeObjTeilnehmertermine.data.teilnehmerkongressterminedata;
      if (teilnehmerkongresstermine.teilnehmerIsModerator == 1) {
        hasModeratorTermin = true;
      }
    }
  });

  let inProgressSpezial = false;

  const congressIMSpezial = operationStore(IMSpezial, { congressId, action: "", actionVeranstaltungId: 0 }, { requestPolicy });

  query(congressIMSpezial);

  congressIMSpezial.subscribe((storeObjIMSpezial) => {
    inProgressSpezial = storeObjIMSpezial.fetching;
    if (!inProgressSpezial && storeObjIMSpezial.data) {
      imspezial = storeObjIMSpezial.data.imspezialdata;

      if (imspezial.startDate) {
        imspezial.startDateObj = new Date();
        imspezial.startDateObj.setTime(Date.parse(imspezial.startDate));
        imspezial.startDateFormated = imspezial.startDateObj.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
      }

      imspezial.eventlist.forEach(function (myEvent) {
        myEvent.startDateObj = new Date();
        myEvent.startDateObj.setTime(Date.parse(myEvent.startDate));
        myEvent.startDateFormated = myEvent.startDateObj.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });
      });
    }
  });

  function stornoTermin(terminId, actionType) {
    congressTeilnehmertermine.variables.action = actionType;
    congressTeilnehmertermine.variables.actionVeranstaltungId = terminId;
    congressTeilnehmertermine.reexecute();
  }
</script>

<p>
  Hier finden Sie eine detaillierte Übersicht Ihrer gebuchten Workshops, Gruppengespräche und One to Ones. Sie können sich von einzelnen Terminen abmelden und diese in Ihren Kalender (im ics-Format)
  eintragen.
</p>

<div class="my-3 grid grid-cols-11 *:p-1" x-transition>
  <div class="col-span-2 flex">
    <img src="/content/im/templates/img/Kongresstool/ico_ws_black.gif" class="not-prose mx-3 my-2 h-8 w-6" alt="Workshop" title="Workshop" />
    <span>
      <strong>WS</strong>:
    </span>
  </div>
  <div class="col-span-3">Workshop</div>
  <div>|</div>
  <div class="col-span-2 flex">
    <img src="/content/im/templates/img/Kongresstool/ico_gg_black.gif" class="not-prose mx-3 my-2 h-8 w-6" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" />
    <span>
      <strong>GG</strong>:
    </span>
  </div>
  <div class="col-span-3">Gruppengespräch</div>

  <div class="col-span-2 flex">
    <img src="/content/im/templates/img/Kongresstool/ico_oo_black.gif" class="not-prose mx-3 my-2 h-8 w-6" alt="One to One" title="One to One" />
    <span>
      <strong>o2o</strong>:
    </span>
  </div>
  <div class="col-span-3">One to One</div>
  <div>|</div>
  <div class="col-span-2 flex">
    <img src="/content/im/templates/img/Kongresstool/SpecialistChartIcon.gif" class="not-prose mx-3 my-2 h-6 w-6" alt="IM Spezial" title="IM Spezial" />
    <span>
      <strong>IM</strong>:
    </span>
  </div>
  <div class="col-span-3">IM Spezial</div>
</div>

<hr class="not-prose my-2" />

<section>
  <p class="flex items-center pt-3 text-theme-signal *:p-1">
    <span
      ><svg class="svg-inline--fa fa-2xs" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
        ><path d="M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"></path></svg
      ></span
    >
    <span class="text-lg font-bold">Termine der Keynote-Speaker</span>
    <button on:click={() => (showStarvortraegeList = !showStarvortraegeList)}>
      {#if showStarvortraegeList}
        <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          ><path
            d="M239 465c9.4 9.4 24.6 9.4 33.9 0L465 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465zM47 81L239 273c9.4 9.4 24.6 9.4 33.9 0L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
          ></path></svg
        >
      {:else}
        <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          ><path
            d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
          ></path></svg
        >
      {/if}
    </button>
  </p>
  {#if showStarvortraegeList}
    <div class="my-3 grid grid-cols-6 *:border *:p-1" x-transition>
      <div class="col-span-1 border-none bg-theme-minor-200"><strong>Speaker</strong></div>
      <div class="col-span-3 border-none bg-theme-minor-200">Thema/Firma</div>
      <div class="border-none bg-theme-minor-200">Tag/Uhrzeit</div>
      <div class="border-none bg-theme-minor-200">Ort</div>
      {#each keynotesspeaker?.eventlist || [] as item}
        <div class="col-span-1"><strong>{item.referent1name}</strong></div>
        <div class="col-span-3">
          <a href="/kongress/vortraege-der-starreferenten/"
            >{item.eventTitle}<svg class="svg-inline--fa fa-2xs ml-1" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
              ><path
                d="M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
              ></path></svg
            ></a
          >
        </div>
        <div class="col-span-1">{item.startDate}<br />{item.startTime}-{item.endTime}</div>
        <div>{item.location}</div>
      {/each}
    </div>
  {/if}
</section>

<section>
  <p class="flex items-center pt-3 text-theme-signal *:p-1">
    <span
      ><svg class="svg-inline--fa fa-2xs" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
        ><path d="M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"></path></svg
      ></span
    >
    <span class="text-lg font-bold">Exklusiv: IM Spezial</span>
    <button on:click={() => (showIMSpezialList = !showIMSpezialList)}>
      {#if showIMSpezialList}
        <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          ><path
            d="M239 465c9.4 9.4 24.6 9.4 33.9 0L465 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465zM47 81L239 273c9.4 9.4 24.6 9.4 33.9 0L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
          ></path></svg
        >
      {:else}
        <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          ><path
            d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
          ></path></svg
        >
      {/if}
    </button>
  </p>
  {#if showIMSpezialList}
    <div class="my-3 grid grid-cols-12 *:border *:p-1" x-transition>
      <div class="col-span-3 border-none bg-theme-minor-200"><strong>Typ</strong></div>
      <div class="col-span-7 border-none bg-theme-minor-200"><strong>Thema</strong></div>
      <div class="col-span-2 border-none bg-theme-minor-200"><strong>Tag/Uhrzeit</strong></div>
      {#each imspezial?.eventlist || [] as item}
        <div class="col-span-3"><strong>{item.typName}</strong></div>
        <div class="col-span-7">
          <a href="/kongress/im-spezial"
            >{item.eventTitle}<svg class="svg-inline--fa fa-2xs ml-1" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
              ><path
                d="M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
              ></path></svg
            ></a
          >
        </div>
        <div class="col-span-2">{item.startDateFormated}<br />{item.startTime}-{item.endTime}</div>
      {/each}
    </div>
  {/if}
</section>

{#if hasModeratorTermin}
  <section>
    <p class="flex items-center pt-3 text-theme-signal *:p-1">
      <span
        ><svg class="svg-inline--fa fa-2xs" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
          ><path d="M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"></path></svg
        ></span
      >
      <span class="text-lg font-bold">Ihr Gruppengesprächstermin</span>
      <button on:click={() => (showModeratorList = !showModeratorList)}>
        {#if showModeratorList}
          <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
            ><path
              d="M239 465c9.4 9.4 24.6 9.4 33.9 0L465 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465zM47 81L239 273c9.4 9.4 24.6 9.4 33.9 0L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
            ></path></svg
          >
        {:else}
          <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
            ><path
              d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
            ></path></svg
          >
        {/if}
      </button>
    </p>
    {#if showModeratorList}
      <div class="my-3 grid grid-cols-12 *:border *:p-1" x-transition>
        <div class="col-span-1 border-none bg-theme-minor-200"><strong>Typ</strong></div>
        <div class="col-span-4 border-none bg-theme-minor-200"><strong>Thema/Firma</strong></div>
        <div class="col-span-3 border-none bg-theme-minor-200"><strong>Referent</strong></div>
        <div class="col-span-2 border-none bg-theme-minor-200"><strong>Tag/Uhrzeit</strong></div>
        <div class="col-span-1 border-none bg-theme-minor-200"><strong>Ort</strong></div>
        <div class="col-span-1 border-none bg-theme-minor-200"></div>
        {#each teilnehmerkongresstermine?.eventlistModerator || [] as item}
          <div class="col-span-1 justify-center" id="v_{item.veranstaltungId}">
            {#if item.typ == 1}
              <img src="/content/im/templates/img/Kongresstool/ico_ws_black.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="Workshop" title="Workshop" /><span class="mx-2"><strong>WS</strong></span>
            {:else if item.typ == 2}
              <img src="/content/im/templates/img/Kongresstool/ico_gg_black.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" /><span class="mx-2"
                ><strong>GG</strong></span
              >
            {:else if item.typ == 3}
              <img src="/content/im/templates/img/Kongresstool/ico_oo_black.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="One to One" title="One to One" /><span class="mx-2"><strong>o2o</strong></span
              >
            {/if}
          </div>
          <div class="col-span-4">
            <a href="/kongress/workshops-gruppengespraeche-one-to-one/?vid={item.veranstaltungId}&gid={item.ausstellerId}&gt={item.typ}" style="text-decoration: underline;"
              >{item.eventTitle}<svg class="svg-inline--fa fa-2xs ml-1" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                ><path
                  d="M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
                ></path></svg
              ></a
            >
          </div>
          <div class="col-span-3">
            {#if item.typ == 1}
              {item.referent1name}, {item.referent1company}{#if item.referent2name != ""}, {item.referent2name}, {item.referent2company}{/if}
            {:else if item.typ == 2}
              <b>Fragen:</b>
              {item.referent2name}
              <b>Antworten:</b>
              {item.referent1name}, {item.referent1company}
            {:else if item.typ == 3}
              {item.referent1name}, {item.referent1company}
            {/if}
          </div>
          <div class="col-span-2">{item.startDate}<br />{item.startTime}-{item.endTime}</div>
          <div class="col-span-1">
            {#if item.typ == 2}Raum
            {:else if item.typ == 1}Saal
            {/if}{item.location}
          </div>
          <div class="col-span-1">
            <a href="/fpi/?eID=icsterminkgv&k={congressId}&vid={item.veranstaltungId}" target="_blank"
              ><img src="/content/im/templates/img/callendarIco.png" class="not-prose mx-3 my-2 h-4 w-4" alt="In Kalender eintragen" title="In Kalender eintragen" /></a
            >
          </div>
        {/each}
      </div>
    {/if}
  </section>
{/if}

<section>
  <p class="flex items-center pt-3 text-theme-signal *:p-1">
    <span
      ><svg class="svg-inline--fa fa-2xs" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
        ><path d="M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"></path></svg
      ></span
    >
    <span class="text-lg font-bold">Für folgende Veranstaltungen ist für Sie ein Sitzplatz reserviert</span>
    <button on:click={() => (showReservedList = !showReservedList)}>
      {#if showReservedList}
        <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          ><path
            d="M239 465c9.4 9.4 24.6 9.4 33.9 0L465 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465zM47 81L239 273c9.4 9.4 24.6 9.4 33.9 0L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
          ></path></svg
        >
      {:else}
        <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          ><path
            d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
          ></path></svg
        >
      {/if}
    </button>
  </p>
  {#if showReservedList}
    <div class="my-3 grid grid-cols-12 *:border *:p-1" x-transition>
      <div class="col-span-1 border-none bg-theme-minor-200"><strong>Typ</strong></div>
      <div class="col-span-4 border-none bg-theme-minor-200"><strong>Thema/Firma</strong></div>
      <div class="col-span-3 border-none bg-theme-minor-200"><strong>Referent</strong></div>
      <div class="col-span-2 border-none bg-theme-minor-200"><strong>Tag/Uhrzeit</strong></div>
      <div class="col-span-1 border-none bg-theme-minor-200"><strong>Ort</strong></div>
      <div class="col-span-1 border-none bg-theme-minor-200"><strong></strong></div>
      {#each teilnehmerkongresstermine?.eventlistReserved || [] as item}
        <div class="col-span-1" id="termin_{item.terminId}">
          {#if item.typ == 1}
            <img src="/content/im/templates/img/Kongresstool/ico_ws_black.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="Workshop" title="Workshop" /><span class="mx-2"><strong>WS</strong></span>
          {:else if item.typ == 2}
            <img src="/content/im/templates/img/Kongresstool/ico_gg_black.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" /><span class="mx-2"
              ><strong>GG</strong></span
            >
          {:else if item.typ == 3}
            <img src="/content/im/templates/img/Kongresstool/ico_oo_black.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="One to One" title="One to One" /><span class="mx-2"><strong>o2o</strong></span>
          {:else if item.typ == 7 || item.typ == 8 || item.typ == 9 || item.typ == 10 || item.typ == 11 || item.typ == 12}
            <img src="/content/im/templates/img/Kongresstool/SpecialistChartIcon.gif" class="not-prose mx-2 my-2 h-6 w-6" alt="IM Spezial" title="IM Spezial" /><span class="mx-2 my-4"
              ><strong>IM</strong></span
            >
          {/if}
        </div>
        <div class="col-span-4">
          {#if item.typ == 7 || item.typ == 8 || item.typ == 9 || item.typ == 10 || item.typ == 11}
            <a href="/kongress/im-spezial/" style="text-decoration: underline;"
              >{item.eventTitle}<svg class="svg-inline--fa fa-2xs ml-1" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                ><path
                  d="M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
                ></path></svg
              ></a
            >
          {:else}
            <a href="/kongress/workshops-gruppengespraeche-one-to-one/?vid={item.veranstaltungId}&gid={item.ausstellerId}&gt={item.typ}" style="text-decoration: underline;"
              >{item.eventTitle}<svg class="svg-inline--fa fa-2xs ml-1" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                ><path
                  d="M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
                ></path></svg
              ></a
            >
          {/if}
        </div>
        <div class="col-span-3">
          {#if item.typ == 1 || item.typ == 6 || item.typ == 12 || item.typ == 7 || item.typ == 8 || item.typ == 9 || item.typ == 10 || item.typ == 11}
            {item.referent1name}{#if item.referent1company != ""}, {item.referent1company}{/if}{#if item.referent2name != ""}, {item.referent2name}, {item.referent2company}{/if}
          {:else if item.typ == 2}
            <b>Fragen:</b>
            {item.referent2name}
            <b>Antworten:</b>
            {item.referent1name}, {item.referent1company}
          {:else if item.typ == 3}
            {item.referent1name}, {item.referent1company}
          {/if}
        </div>
        <div class="col-span-2">{item.startDate}<br />{item.startTime}-{item.endTime}</div>
        <div class="col-span-1">
          {#if item.typ == 2}Raum
          {:else if item.typ == 1 || item.typ == 6 || item.typ == 12 || item.typ == 7 || item.typ == 8 || item.typ == 9 || item.typ == 10 || item.typ == 11}Saal
          {/if}{item.location}
        </div>
        <div class="col-span-1">
          <a href="/fpi/?eID=icsterminkgv&k={congressId}&tid={item.terminId}" target="_blank"
            ><img src="/content/im/templates/img/callendarIco.png" class="not-prose mx-3 my-2 h-4 w-4" alt="In Kalender eintragen" title="In Kalender eintragen" /></a
          >
          {#if item.typ == 3}
            &nbsp;
          {:else}
            <button on:click={() => stornoTermin(item.terminId, "unbooking")}>
              <img src="/content/im/templates/img/round_delete_black.png" class="not-prose mx-3 my-2 h-4 w-4" alt="Termin löschen" title="Termin löschen" />
            </button>
          {/if}
        </div>
      {/each}
    </div>
  {/if}
</section>

<section>
  <p class="flex items-center pt-3 text-theme-signal *:p-1">
    <span
      ><svg class="svg-inline--fa fa-2xs" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"
        ><path d="M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96z"></path></svg
      ></span
    >
    <span class="text-lg font-bold">Für folgende Veranstaltungen stehen Sie auf der Warteliste</span>
    <button on:click={() => (showWaitingList = !showWaitingList)}>
      {#if showWaitingList}
        <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          ><path
            d="M239 465c9.4 9.4 24.6 9.4 33.9 0L465 273c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 239c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 465zM47 81L239 273c9.4 9.4 24.6 9.4 33.9 0L465 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9z"
          ></path></svg
        >
      {:else}
        <svg class="svg-inline--fa fa-md" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
          ><path
            d="M465 239c9.4 9.4 9.4 24.6 0 33.9L273 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L239 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L465 239zM81 47L273 239c9.4 9.4 9.4 24.6 0 33.9L81 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L47 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0z"
          ></path></svg
        >
      {/if}
    </button>
  </p>
  {#if showWaitingList}
    <div class="my-3 grid grid-cols-12 *:border *:p-1" x-transition>
      <div class="col-span-1 border-none bg-theme-minor-200"><strong>Typ</strong></div>
      <div class="col-span-4 border-none bg-theme-minor-200"><strong>Thema/Firma</strong></div>
      <div class="col-span-3 border-none bg-theme-minor-200"><strong>Referent</strong></div>
      <div class="col-span-2 border-none bg-theme-minor-200"><strong>Tag/Uhrzeit</strong></div>
      <div class="col-span-1 border-none bg-theme-minor-200"><strong>Ort</strong></div>
      <div class="col-span-1 border-none bg-theme-minor-200"><strong></strong></div>
      {#each teilnehmerkongresstermine?.eventlistWaiting || [] as item}
        <div class="col-span-1">
          {#if item.typ == 1}
            <img src="/content/im/templates/img/Kongresstool/ico_ws_black.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="Workshop" title="Workshop" /><span class="mx-2"><strong>WS</strong></span>
          {:else if item.typ == 2}
            <img src="/content/im/templates/img/Kongresstool/ico_gg_black.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="Gruppengespr&auml;ch" title="Gruppengespr&auml;ch" /><span class="mx-2"
              ><strong>GG</strong></span
            >
          {:else if item.typ == 3}
            <img src="/content/im/templates/img/Kongresstool/ico_oo_black.gif" class="not-prose mx-2 my-2 h-8 w-6" alt="One to One" title="One to One" /><span class="mx-2"><strong>o2o</strong></span>
          {/if}
        </div>
        <div class="col-span-4">
          <a href="/kongress/workshops-gruppengespraeche-one-to-one/?vid={item.veranstaltungId}&gid={item.ausstellerId}&gt={item.typ}" style="text-decoration: underline;"
            >{item.eventTitle}<svg class="svg-inline--fa fa-2xs ml-1" aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
              ><path
                d="M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
              ></path></svg
            ></a
          >
        </div>
        <div class="col-span-3">
          {#if item.typ == 1}
            {item.referent1name}, {item.referent1company}{#if item.referent2name != ""}, {item.referent2name}, {item.referent2company}{/if}
          {:else if item.typ == 2}
            <b>Fragen:</b>
            {item.referent2name}
            <b>Antworten:</b>
            {item.referent1name}, {item.referent1company}
          {:else if item.typ == 3}
            {item.referent1name}, {item.referent1company}
          {/if}
        </div>
        <div class="col-span-2">{item.startDate}<br />{item.startTime}-{item.endTime}</div>
        <div class="col-span-1">
          {#if item.typ == 2}Raum
          {:else if item.typ == 1}Saal
          {/if}{item.location}
        </div>
        <div class="col-span-1">
          <a href="/fpi/?eID=icsterminkgv&k={congressId}&tid={item.terminId}" target="_blank"
            ><img src="/content/im/templates/img/callendarIco.png" class="not-prose mx-3 my-2 h-4 w-4" alt="In Kalender eintragen" title="In Kalender eintragen" /></a
          >
          <button on:click={() => stornoTermin(item.terminId, "unbookingWaitinglist")}>
            <img src="/content/im/templates/img/round_delete_black.png" class="not-prose mx-3 my-2 h-4 w-4" alt="Termin löschen" title="Termin löschen" />
          </button>
        </div>
      {/each}
    </div>
  {/if}
</section>
